import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  activeTab = 'Client Contacts';
  tabs = [
    'Client Contacts',
    'Program Contact',
    'Lien Representative',
    'Prospective Client',
    'Employee',
    'Defense Attorneys',
    'Applicant Attorneys',
    'Other'
  ];

  private unsubscribe$ = new Subject<void>();

  constructor() {}

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
